import { useEffect } from 'react'
import { isMobileWebViewport } from './mobileViewport'

const HTML_LOCK_CLASS = 'map-pipeline-modal-open'

/** Prevent Safari page rubberband while a full-screen map modal is open (mobile web). */
export function useLockPageScrollWhileOpen(active: boolean): void {
  useEffect(() => {
    if (!active || !isMobileWebViewport()) return

    const html = document.documentElement
    const body = document.body
    const scrollY = window.scrollY

    html.classList.add(HTML_LOCK_CLASS)
    body.style.top = `-${scrollY}px`
    body.style.width = '100%'

    return () => {
      html.classList.remove(HTML_LOCK_CLASS)
      body.style.top = ''
      body.style.width = ''
      window.scrollTo(0, scrollY)
    }
  }, [active])
}
